import React from 'react'
import ProgressUI from '../../widgets/output/ProgressUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import LabelAndValueUI from '../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import BudgetListUI from '../../components/finapp/budget/BudgetListUI'
import OrderHeaderUI from '../../components/finapp/order/OrderHeaderUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import BudgetCreateModalSF from '../../components/finapp/budget/BudgetCreateModalSF'
import './BudgetListPage.css'

const BudgetListPageUI = ({ context, messageList, errorList, order, budgetList, filteredBudgetList,
  searchFilter, onRefreshClick, onSearchFilterChange,
  createBudgetMode, onCreateBudgetClick, onCancelCreateBudget, onCreateBudgetComplete
}) =>
  <PrivatePageSF context={context} className='pg_ord_budgets' backLink='/orders'
    messageList={messageList} headerMessageKey='c_budgets'
    centered={(!order || !budgetList) && !errorList}
  >
    {
      (!order || !budgetList) && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      order && budgetList &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink='/orders'
          messageList={messageList} titleMessageKey='c_budgets'
        />
        <OrderHeaderUI context={context} messageList={messageList} order={order} />
        <BudgetListHeaderUI context={context} messageList={messageList} order={order} />
      </React.Fragment>
    }
    {
      budgetList && budgetList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        onCreateClick={onCreateBudgetClick}
        createLinkKey='c_create_budget'
        createDisabledMessageKey='c_no_budget_msg'
      />
    }
    {
      order && budgetList && filteredBudgetList && budgetList.length !== 0 &&
      <BudgetListUI
        context={context}
        order={order}
        budgetList={filteredBudgetList}
        messageList={messageList}
        searchFilter={searchFilter}
        // events
        onRefreshClick={onRefreshClick}
        onSearchFilterChange={onSearchFilterChange}
        onCreateClick={onCreateBudgetClick}
      />
    }
    <BudgetCreateModalSF context={context} createMode={createBudgetMode}
      onCancelClick={onCancelCreateBudget} onCreateComplete={onCreateBudgetComplete}
    />
  </PrivatePageSF>

const BudgetListHeaderUI = ({ context, messageList, order }) =>
  <React.Fragment>
    <div className='g_flex_h g_m_top_50'>
      <ProgressUI messageList={messageList} labelKey='c_allocated' percent={order.budgetAssignedPercent} />
      <LabelAndValueUI messageList={messageList} labelKey='c_budget_total' align='right'>
        {order.budgetTotalF2}
      </LabelAndValueUI>
    </div>
    <div className='g_flex_h g_m_top_50'>
      <ProgressUI messageList={messageList} labelKey='c_utilized' percent={order.budgetSpentPercent} />
      <LabelAndValueUI messageList={messageList} labelKey='c_avail_to_alloc' align='right'>
        {order.budgetAvailableF2}
      </LabelAndValueUI>
    </div>
  </React.Fragment>

export default BudgetListPageUI
